module.exports = {"zh":"中文","Developer":"Developer","Type":"Type","TotalUnits":"Total Units","ExpTop":"Exp Top","Address":"Address","Location":"Location","Tenure":"Tenure","Country":"Country"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/zh.json
// module id = ODm5
// module chunks = 18